import { RouteRecordRaw } from 'vue-router'

import debugRoutes from 'src/system/debug/routes'
import authRoutes from 'src/system/auth/routes'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'root',
    component: () => import('../layouts/MainLayout.vue'),
    children: [
      { path: 'test', name: 'test', component: () => import('../pages/TestPage.vue') },
      ...authRoutes,
      ...debugRoutes,
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('../pages/ErrorNotFound.vue'),
  },
]

export default routes
